export enum ClientRealtimeEventType {
  TextInput = 'input.text',
  ImageInput = 'input.image',
  AudioInputAppend = 'input.audio.append',
  AudioInputRaw = 'input.audio.raw',
  AudioInputCommit = 'input.audio.commit',
  SessionStop = 'session.stop',
  ConnectionClose = 'connection.close'
}

export enum RealtimeMessageType
{
    ConnectionAccepted= 'connection.accepted',
    Heartbeat = 'heartbeat',
    Error = 'error',
    OutputTextDelta = 'output.text.delta',
    SessionCreated = 'session.created',
    InputAudioTranscriptDone = "input.audio.transcript.done",
    InputAudioTranscriptFailed = "input.audio.transcript.failed",
    OutputAudioTranscriptDelta = 'output.audio.transcript.delta',
    OutputTextDone = 'output.text.done',
    FunctionCallArgumentsDelta = 'function.call.arguments.delta',
    FunctionCallArgumentsDone = 'function.call.arguments.done',
    ResponseDone = 'response.done',
    OutputAudioDelta = 'output.audio.delta',
    SessionCompleted = 'session.completed',
    ConversationCreated = 'conversation.created',
    ConversationUpdated = 'conversation.updated',
    ServerStatus = 'server.status'
}



